/**
 * Copy för styrelsepresentationen.
 *
 * Beskriver mötet så som det är tänkt att gå till, från kallelse till arkiverat protokoll.
 */

export const ÄMNEN = [
    { id: 'a1', rubrik: 'Offert för stambyte etapp 2', av: 'Karin' },
    { id: 'a2', rubrik: 'Cykelrummet på plan −1', av: 'Ahmed' },
    { id: 'a3', rubrik: 'Andrahandsansökan lgh 1102', av: 'Karin' },
    { id: 'a4', rubrik: 'Budget för yttre underhåll', av: 'Johan' },
    { id: 'a5', rubrik: 'Laddstolpar i garaget', av: 'Mira' }
];

export const LEDAMÖTER = [
    { id: 'l1', namn: 'Karin Ehn', roll: 'Ordförande' },
    { id: 'l2', namn: 'Johan Sahlin', roll: 'Kassör' },
    { id: 'l3', namn: 'Mira Lindqvist', roll: 'Sekreterare' },
    { id: 'l4', namn: 'Ahmed Rahal', roll: 'Ledamot' }
];

export const PROTOKOLLRADER = [
    '§ 1  Mötets öppnande',
    '§ 2  Val av justerare',
    '§ 3  Föregående protokoll',
    '§ 4  Offert stambyte etapp 2 — beslut: inhämta ett tredje anbud',
    '§ 5  Cykelrummet plan −1 — beslut: rensning i oktober',
    '§ 6  Laddstolpar i garaget — bordläggs',
    '§ 7  Mötets avslutande'
];

export const TJÄNSTER = [
    { id: 'calendar', etikett: 'Calendar', under: 'Kallelse' },
    { id: 'meet', etikett: 'Meet', under: 'Mötesrum' },
    { id: 'drive', etikett: 'Drive', under: 'Arkiv' },
    { id: 'gmail', etikett: 'Gmail', under: 'Utskick' }
];
